import { QuickFinderUserDialog } from 'app/components/QuickFinderUserDialog';
import { Button, Typography } from 'app/design';
import { useUserQuery } from 'app/hooks/queries/user';
import { useToggleReducer } from 'app/utilities';
import React from 'react';
import { useFormContext } from 'react-hook-form';

// interface declaring which props are required/allowed
// interface UserProps {
//   // directoryId: string;
//   callflow?: any;
//   open?: boolean;
//   onCancel: () => void;
//   // onComplete: () => void;
// }

const User = ({ item, modifyPath, onChangeSimple, ...rest }) => {
  // console.log('USERUSER:', { item, modifyPath, rest });
  const { varItem, moduleItem, moduleModifyPath } = item;
  const {
    register,
    formState: { errors: formErrors, isDirty, dirtyFields },
    setError,
    watch,
    control,
    setValue,
  } = useFormContext();

  const [showFinderDialog, toggleShowFindDialog] = useToggleReducer(false);

  const key = varItem.key;
  const variables = watch(`${modifyPath}callflow.strategy.simple.variables`);

  // simple variable values
  const currentVarOutputValue = varItem.output_value;
  const defaultValueInFlow = varItem.output_value_default;
  const simpleValueInCallflow = variables[key];

  // get CURRENT value FROM MODULE
  // - for when saved by the Advanced Editor!
  //   - that doesnt update the varItem, it only updates the actual flow!
  const currentValue = moduleItem?.data?.data?.id;

  const {
    data: userCurrent,
    isLoading: userCurrentIsLoading,
    isFetched: userCurrentIsFetched,
  } = useUserQuery(currentValue);

  const {
    data: userSimple,
    isLoading: userSimpleIsLoading,
    isFetched: userSimpleIsFetched,
  } = useUserQuery(simpleValueInCallflow);

  const onChangeSelect = selected => {
    const [userId] = selected;
    setValue(`${modifyPath}callflow.strategy.simple.variables.${key}`, userId, {
      shouldDirty: true,
    });
    // TODO: this may work for "account no_schedule" but may fail at others, need to verify
    // - we're doing this so that the "simple" value is applied immediately!
    //   - maybe should emit an event that rebuilds, instead?
    setValue(`${modifyPath}callflow${moduleModifyPath}.data.data.id`, userId, {
      shouldDirty: true,
    });
    onChangeSimple && onChangeSimple();

    // setAtPath(tmpModuleItem, `data.id`, userId); // newValue?.value === id
    // setModifyModuleItem({ ...tmpModuleItem });
    toggleShowFindDialog();
  };

  const handleClear = () => {
    // setAtPath(tmpModuleItem, `data.id`, null); // newValue?.value === id
    // setModifyModuleItem({ ...tmpModuleItem });
    // toggleShowFindDialog();
  };

  // console.log('varitem User:', varItem, {
  //   currentValue,
  //   simpleValueInCallflow,
  //   callflow: watch(`${modifyPath}callflow`),
  // });

  return (
    <div>
      {showFinderDialog ? (
        <QuickFinderUserDialog
          onSelect={onChangeSelect}
          onCancel={toggleShowFindDialog}
          onClear={handleClear}
          initialSelected={simpleValueInCallflow ? [simpleValueInCallflow] : []}
          selectionTitle={userSimple ? `${userSimple.extra.fullName}` : null}
          allowSelectNone
        />
      ) : null}
      <Typography variant="h3">User:</Typography>

      <Typography variant="bodyBig" sx={{ fontWeight: 'bold' }} paragraph>
        {userCurrentIsLoading
          ? 'Loading...'
          : userCurrent
          ? userCurrent.extra?.fullName ?? 'Invalid user'
          : 'None set'}
      </Typography>

      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={toggleShowFindDialog}
      >
        Change User
      </Button>
      {/* <Typography variant="body1">
        Current:{' '}
        {userCurrentIsLoading
          ? 'Loading...'
          : userCurrent
          ? userCurrent.extra?.fullName ?? 'Invalid user'
          : 'None set'}
      </Typography>
      <Typography variant="body1" onClick={toggleShowFindDialog}>
        Custom:
        {userSimpleIsLoading
          ? 'Loading...'
          : userSimple
          ? userSimple.extra?.fullName ?? 'Invalid user'
          : 'None set'}
      </Typography> */}
    </div>
  );
};

export default User;
